import { CustomField } from './custom-field.model';
import { BillableItem, BillableItemFormType } from './billable-item.model';
import { CourtTask, CourtTaskForm } from './court-task.model';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { BaseTask, BaseTaskForm } from './base-task.model';
import { DocumentGenerationEntry, DocumentGenerationEntryForm } from './document-generation-entry.model';

/**
 * Maps the interactive document-generation selection to the `documents` array the backend
 * generator reads (GenerateDocumentDTO.documents). Shared by the action-center step-completion
 * path (EvictionService.saveStepCompletion) and the New-Eviction create path so both submit the
 * same shape; extra entry fields (e.g. conditional_rule) are intentionally dropped. Returns [] for
 * a null/empty selection.
 */
export function mapDocumentGenerationToDocuments(
  entries: DocumentGenerationEntry[] | null | undefined
): { document_template_id: string; hide_from_client: boolean }[] {
  return (entries ?? []).map((entry) => ({
    document_template_id: entry.document_template_id,
    hide_from_client: entry.hide_from_client
  }));
}

export interface StepCompletionModel {
  step: number;
  comment?: string;
  notes?: string;
  case_id?: string;
  court_result?: string;
  skipped: boolean;
  close_case: boolean;
  /** Unified single-array document generation model (Req 3.2). */
  document_generation?: DocumentGenerationEntry[];
  /**
   * Resolved document selection the backend generator actually reads
   * (GenerateDocumentDTO.documents). Derived from document_generation at submit time —
   * see EvictionService.saveStepCompletion and the create-eviction submit.
   */
  documents?: { document_template_id: string; hide_from_client: boolean }[];
  /**
   * @deprecated Retained only for the copied-eviction workflow path that still
   * mounts the legacy DocumentSelectorComponent. Use document_generation instead.
   */
  document_templates?: string[];
  /**
   * @deprecated Retained only for the copied-eviction workflow path that still
   * mounts the legacy DocumentSelectorComponent. Use document_generation instead.
   */
  hidden_document_templates?: string[];
  custom_fields?: CustomField[];
  billable_items?: BillableItem[];
  tasks?: BaseTask[];
  new_court_task?: CourtTask;
  judgement_result?: CourtTask;
  skip_to_step?: number;
}

export type StepCompletionForm = FormGroup<{
  step: FormControl<number>;
  comment: FormControl<string>;
  notes: FormControl<string>;
  case_id: FormControl<string>;
  court_result: FormControl<string>;
  skipped: FormControl<boolean>;
  close_case: FormControl<boolean>;
  /** Unified single-array document generation model (Req 3.2). */
  document_generation: FormArray<DocumentGenerationEntryForm>;
  /** @deprecated Retained only for the legacy copied-eviction selector path. */
  document_templates: FormControl<string[]>;
  /** @deprecated Retained only for the legacy copied-eviction selector path. */
  hidden_document_templates: FormControl<string[]>;
  tasks: FormArray<BaseTaskForm>;
  custom_fields: FormArray<any>;
  billable_items: FormArray<BillableItemFormType>;
  new_court_task: FormControl<CourtTaskForm>;
  judgement_result: FormControl<CourtTaskForm>;
}>;
